module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "single_small_soproni_box_area"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "single_small_soproni_box_cont_all"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.products != null) ? _vm._l((_vm.products), function(p) {
    return _c('product-list-view', {
      key: p.id,
      attrs: {
        "product": p
      }
    })
  }) : _vm._e()], 2)])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.suv) ? _c('div', {
    staticClass: "up-div"
  }, [_c('a', {
    staticStyle: {
      "color": "white"
    },
    on: {
      "click": _vm.toTop
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-up fa-3x"
  })])]) : _vm._e()])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8f9b93ea","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/main/components/pages/list/Products.vue
// module id = 123
// module chunks = 0 1 2